



























import { Component } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import DepositCurrentAccountWizard from '@/components/Products/Wizard/DepositCurrentAccountWizard.vue';
import DepositSavingsAccountWizard from '@/components/Products/Wizard/DepositSavingsAccountWizard.vue';
import DepositFixedTermWizard from '@/components/Products/Wizard/DepositFixedTermWizard.vue';
import DepositNoticeAccountWizard from '@/components/Products/Wizard/DepositNoticeAccountWizard.vue';
import LendingFixedTermWizard from '@/components/Products/Wizard/LendingFixedTermWizard.vue';
import LendingRevolvingCreditWizard from '@/components/Products/Wizard/LendingRevolvingCreditWizard.vue';
import ProductSubType from '@/models/Products/ProductSubType';

@Component({ name: 'ProductWizard', components: {
    Alert,
    DepositSavingsAccountWizard,
    DepositCurrentAccountWizard,
    DepositFixedTermWizard,
    DepositNoticeAccountWizard,
    LendingFixedTermWizard,
    LendingRevolvingCreditWizard
}, metaInfo: { title: 'Product Wizard' } })
export default class extends SaascadaVue {

    ProductSubType = ProductSubType;

    async beforeMount() {
        await ProductWizardModule.clearProductViewModel();
    }

    get productSubType() {
        if (this.$route.query.productSubType) {
            return this.$route.query.productSubType;
        }
        return null;
    }

    get loading() {
        return false;
    }

    get productVM() {
        return ProductWizardModule.createProductViewModel;
    }

}
